export class ValidatorPatternConstant {
  public static PHONE_NUMBER = '^0\\d{9}$|\\+84\\d{9}$';
}
